import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { adminRoutes, schoolAdminRoutes, userRoutes } from './routes';
import { USER_ROLE } from '../config/Constants';

function AuthProvider() {
  const user = useSelector((state) => state.user);
  const location = useLocation();
  const { pathname } = location;

  if (!user?.role) {
    return <Navigate to="/" />;
  }

  if (user.role?.id === USER_ROLE.SCHOOL_ADMIN && adminRoutes.some((r) => r.path === pathname)) {
    return <Navigate to="/404" />;
  }

  if (
    user.role?.id === USER_ROLE.ADMIN &&
    (schoolAdminRoutes.some((r) => r.path === pathname) || userRoutes.some((r) => r.path === pathname))
  ) {
    return <Navigate to="/404" />;
  }

  return <Outlet />;
}
export default AuthProvider;
